'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _flatten = require('lodash/fp/flatten');

var _flatten2 = _interopRequireDefault(_flatten);

var _orderBy = require('lodash/fp/orderBy');

var _orderBy2 = _interopRequireDefault(_orderBy);

var _flow = require('lodash/fp/flow');

var _flow2 = _interopRequireDefault(_flow);

var _semanticUiReact = require('semantic-ui-react');

var _reactChartjs = require('react-chartjs-2');

var _influencerReportCard = require('./../influencer-report-card');

var _influencerReportCard2 = _interopRequireDefault(_influencerReportCard);

var _reportHeader = require('./../report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _asaCompliance = require('./../asa-compliance');

var _asaCompliance2 = _interopRequireDefault(_asaCompliance);

var _instagramIcon = require('./../instagram-icon');

var _instagramIcon2 = _interopRequireDefault(_instagramIcon);

var _externalLink = require('./../external-link');

var _externalLink2 = _interopRequireDefault(_externalLink);

var _unavailableData = require('./../unavailable-data');

var _unavailableData2 = _interopRequireDefault(_unavailableData);

var _formatting = require('./../../utils/formatting');

var _colors = require('./../../utils/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chartOptions = {
  legend: {
    position: 'left'
  }
};

var theRestChartColours = {
  main: 'rgba(140, 140, 140, .7)',
  background: 'rgba(140, 140, 140, 1)'
};

var EmptyDataComponent = function EmptyDataComponent() {
  return _react2.default.createElement(_unavailableData2.default, { iconName: 'circle thin', iconColor: 'grey', content: 'This channel does not support this data.' });
};

var hostname = _lodash2.default.toLower(window.location.hostname);
var isVoxo = hostname.match(/voxogram/);
var isGifta = hostname.match(/gifta/);
var platformName = isVoxo ? 'voxogram' : 'dyzio';
var platformUrl = isVoxo ? 'www.voxogram.com' : 'dyzio.co';

var PrivateDataComponent = function PrivateDataComponent() {
  return _react2.default.createElement(_unavailableData2.default, {
    iconName: 'lock', iconColor: 'orange', content: 'This is private data.\n            You need to ask the influencer to log in and authorise\n            ' + platformName + ' to fetch it for you.'
  });
};

var getTopFivePieChartData = function getTopFivePieChartData(all, valueKey) {
  var firstFive = _lodash2.default.take(all, 5);
  var lastFive = _lodash2.default.slice(all, 5);

  var labels = _lodash2.default.map(firstFive, 'handle');

  var data = _lodash2.default.map(firstFive, function (item) {
    return _lodash2.default.get(item, 'values.totals.' + valueKey, 0);
  });

  labels.push('the rest');
  data.push(_lodash2.default.sumBy(lastFive, 'values.totals.' + valueKey));

  var bgColors = _lodash2.default.map(firstFive, 'colors.mainColor');
  var borderColors = _lodash2.default.map(firstFive, 'colors.borderColor');

  return {
    labels: labels,
    datasets: [{
      data: data,
      backgroundColor: [].concat((0, _toConsumableArray3.default)(bgColors), [theRestChartColours.main]),
      borderColor: [].concat((0, _toConsumableArray3.default)(borderColors), [theRestChartColours.background]),
      borderWidth: 1
    }]
  };
};

var totalStyles = {
  backgroundColor: 'rgba(0,0,0,.05)',
  fontWeight: 'bold'
};

var getSortField = function getSortField(key) {
  var values = {
    'values.totals.followersCount': 'followerCount',
    'values.totals.likes': 'likeCount',
    'values.totals.comments': 'commentCount',
    'values.totals.views': 'viewCount'
  };
  return values[key];
};
var summaryStyle = {
  marginBottom: 50
};
var rightBordered = {
  borderRight: '1px solid #e0e0e0',
  marginLeft: -1
};
var textTransformNormal = {
  textTransform: 'none'
};
var mostEffectiveStyle = {
  textAlign: 'center',
  padding: 10,
  backgroundColor: _colors.dyzioPalette.white
};

var ReportRowIG = function ReportRowIG(_ref) {
  var post = _ref.post;

  var isStory = post.type === 'stories';
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_instagramIcon2.default, { post: post })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      post.influencerName || post.handle
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      post.text
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(post.viewCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(_lodash2.default.get(post, isStory ? 'attributes.latestImpressions' : 'insights.impressions', 0))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(_lodash2.default.get(post, isStory ? 'attributes.latestReach' : 'insights.reach', 0))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(post.likeCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(EmptyDataComponent, null)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      (0, _formatting.commaFormatted)(post.commentCount)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(EmptyDataComponent, null)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_asaCompliance2.default, { text: post.text })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_externalLink2.default, { post: post })
    )
  );
};

var InstagramReport = function InstagramReport(props) {
  var _props$data$data = props.data.data,
      name = _props$data$data.name,
      createdBy = _props$data$data.createdBy,
      influencers = _props$data$data.influencers,
      postsCount = _props$data$data.postsCount,
      liveDate = _props$data$data.liveDate,
      endDate = _props$data$data.endDate,
      totalViews = _props$data$data.totalViews,
      totalLikes = _props$data$data.totalLikes,
      totalComments = _props$data$data.totalComments,
      posts = _props$data$data.posts;
  var sort = props.sort,
      groupBy = props.groupBy,
      onSortChanged = props.onSortChanged,
      onGroupByChanged = props.onGroupByChanged,
      withHeader = props.withHeader;


  var allPosts = _lodash2.default.compact(_lodash2.default.reduce(posts, function (result, item) {
    result.push(item.posts);
    return result;
  }, []));

  var ungroupedPosts = (0, _flow2.default)(_flatten2.default, (0, _orderBy2.default)(function (it) {
    var key = getSortField(sort);
    return it[key] || 0;
  }, ['desc']))(_lodash2.default.compact(allPosts));

  var items = _lodash2.default.map(posts, function (values, handle) {
    var position = _lodash2.default.keys(posts).indexOf(handle);
    return { handle: handle, values: values, colors: (0, _colors.getRowColors)(position) };
  });

  var totalImpressions = _lodash2.default.sumBy(ungroupedPosts, function (item) {
    var isStory = _lodash2.default.get(item, 'type', null) === 'stories';
    if (isStory) {
      if (_lodash2.default.has(item, 'attributes.storyData') && _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'))) {
        var storyData = _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'));
        return _lodash2.default.get(storyData, 'impressions', 0);
      }
      if (_lodash2.default.has(item, 'trackedAsset.insights.impressions')) {
        return _lodash2.default.get(item, 'trackedAsset.insights.impressions', 0);
      }
      if (_lodash2.default.has(item, 'attributes.latestImpressions')) {
        return _lodash2.default.get(item, 'attributes.latestImpressions', 0);
      }
    }
    return _lodash2.default.get(item, 'insights.impressions', 0);
  });

  var totalReach = _lodash2.default.sumBy(ungroupedPosts, function (item) {
    var isStory = _lodash2.default.get(item, 'type', null) === 'stories';
    if (isStory) {
      if (_lodash2.default.has(item, 'attributes.storyData') && _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'))) {
        var storyData = _lodash2.default.last(_lodash2.default.get(item, 'attributes.storyData'));
        return _lodash2.default.get(storyData, 'reach', 0);
      }
      if (_lodash2.default.has(item, 'trackedAsset.insights.reach')) {
        return _lodash2.default.get(item, 'trackedAsset.insights.reach', 0);
      }
      if (_lodash2.default.has(item, 'attributes.latestReach')) {
        return _lodash2.default.get(item, 'attributes.latestReach', 0);
      }
    }
    return _lodash2.default.get(item, 'insights.reach', 0);
  });

  // console.log(`totalReach=${totalReach}`);

  var menuOptions = [{
    onClick: onSortChanged,
    key: 'folowers',
    active: sort === 'values.totals.followersCount',
    value: 'values.totals.followersCount',
    name: 'followers',
    icon: 'user'
  }, {
    onClick: onSortChanged,
    key: 'likes',
    active: sort === 'values.totals.likes',
    value: 'values.totals.likes',
    name: 'likes',
    icon: 'empty heart'
  }, {
    onClick: onSortChanged,
    key: 'comments',
    active: sort === 'values.totals.comments',
    value: 'values.totals.comments',
    name: 'comments',
    icon: 'comments outline'
  }, {
    onClick: onSortChanged,
    key: 'views',
    active: sort === 'values.totals.views',
    value: 'values.totals.views',
    name: 'views',
    icon: 'video play'
  }, {
    onClick: onGroupByChanged,
    key: 'influencer',
    active: groupBy === 'influencer',
    position: 'right',
    value: 'influencer',
    name: 'influencer',
    icon: 'user circle outline'
  }, {
    onClick: onGroupByChanged,
    key: 'none',
    active: groupBy === 'none',
    value: 'none',
    name: 'none',
    icon: 'circle outline'
  }];

  var orderedByLikes = _lodash2.default.orderBy(items, 'values.totals.likes', 'desc');
  var orderedByComments = _lodash2.default.orderBy(items, 'values.totals.comments', 'desc');
  var orderedByViews = _lodash2.default.orderBy(items, 'values.totals.views', 'desc');

  var likesChartData = getTopFivePieChartData(orderedByLikes, 'likes');
  var commentsChartData = getTopFivePieChartData(orderedByComments, 'comments');
  var viewsChartData = getTopFivePieChartData(orderedByViews, 'views');

  var views = _lodash2.default.head(viewsChartData.datasets).data;
  var shouldDisplayViewsChart = _lodash2.default.find(views, function (x) {
    return x > 0;
  });

  var isEmptyCampaign = _lodash2.default.size(posts) === 0;

  var noBorderTop = {
    borderTop: 'none'
  };

  var headerInfo = {
    hasLogo: false,
    campaignName: name,
    reportDate: liveDate,
    reportType: 'Instagram',
    liveDate: liveDate,
    endDate: endDate
  };
  return _react2.default.createElement(
    'div',
    null,
    isEmptyCampaign && _react2.default.createElement(
      _semanticUiReact.Message,
      { icon: 'icon', warning: 'warning' },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning' }),
      _react2.default.createElement(
        _semanticUiReact.Message.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message.Header,
          null,
          'Warning'
        ),
        'No Instagram posts included in this campaign'
      )
    ),
    withHeader && _react2.default.createElement(
      _semanticUiReact.Card,
      { fluid: 'fluid', color: 'pink' },
      _react2.default.createElement(
        _semanticUiReact.Card.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Message,
          { icon: 'icon' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file text outline', color: 'pink' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              name
            ),
            'created by ',
            createdBy
          )
        ),
        _react2.default.createElement(_reportHeader2.default, { info: headerInfo })
      )
    ),
    !isEmptyCampaign && _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _semanticUiReact.Card,
        { fluid: 'fluid', style: summaryStyle, color: 'pink' },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { style: noBorderTop },
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            'Campaign Summary'
          ),
          _react2.default.createElement(
            _semanticUiReact.Card.Meta,
            null,
            'engagements and viewing across Instagram'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Statistic.Group,
            { color: 'pink', widths: 6 },
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              { style: rightBordered },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(influencers)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'user circle outline' }),
                'influencers'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              { style: rightBordered },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(totalViews)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'video play outline' }),
                'views'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              { style: rightBordered },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(totalComments)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' }),
                'comments'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              { style: rightBordered },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(totalLikes)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
                'likes'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              { style: rightBordered },
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(postsCount)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
                'assets'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Statistic,
              null,
              _react2.default.createElement(
                _semanticUiReact.Statistic.Value,
                { style: textTransformNormal },
                (0, _formatting.sciFormatted)(totalImpressions)
              ),
              _react2.default.createElement(
                _semanticUiReact.Statistic.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
                'impressions'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            'h3',
            { style: mostEffectiveStyle },
            'Who was the most effective influencer?'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              columns: shouldDisplayViewsChart ? 3 : 2, divided: 'divided', textAlign: 'center'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'likes by influencer'
                ),
                _react2.default.createElement(_reactChartjs.Doughnut, { data: likesChartData, options: chartOptions })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'comments by influencer'
                ),
                _react2.default.createElement(_reactChartjs.Doughnut, { data: commentsChartData, options: chartOptions })
              ),
              shouldDisplayViewsChart && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'views by influencer (videos only)'
                ),
                _react2.default.createElement(_reactChartjs.Doughnut, { data: viewsChartData, options: chartOptions })
              )
            )
          )
        ),
        !isGifta && _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { textAlign: 'center' },
          _react2.default.createElement(
            'a',
            { rel: 'noopener noreferrer', href: 'https://' + platformUrl, target: '_blank' },
            'influencer analytics - powered by ',
            platformName
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8 },
            _react2.default.createElement(
              'b',
              null,
              'SORT BY'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, textAlign: 'right' },
            _react2.default.createElement(
              'b',
              null,
              'GROUP BY'
            )
          )
        )
      ),
      _react2.default.createElement(_semanticUiReact.Menu, { items: menuOptions }),
      (!groupBy || groupBy === 'influencer') && _react2.default.createElement(
        _semanticUiReact.Card.Group,
        { itemsPerRow: 4 },
        _lodash2.default.map(_lodash2.default.orderBy(items, sort, 'desc'), function (value, idx) {
          return _react2.default.createElement(_influencerReportCard2.default, { value: value, key: idx });
        })
      ),
      groupBy && groupBy === 'none' && _react2.default.createElement(
        _semanticUiReact.Card,
        { fluid: 'fluid' },
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            singleLine: 'singleLine', celled: 'celled', fixed: 'fixed', basic: 'very', size: 'small', textAlign: 'center', style: {
              marginTop: 20
            }
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'platform'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'influencer'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'title'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'views'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'impressions'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'reach'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs up', color: 'grey' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs down', color: 'grey' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments', color: 'grey' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'share', color: 'grey' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'grey' }),
                    ' #ad ? '
                  ), content: 'This confirms that the post includes #ad, #spon, #partner'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'view'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _lodash2.default.map(ungroupedPosts, function (post) {
              return _react2.default.createElement(ReportRowIG, { post: post });
            }),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { style: totalStyles },
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'viewCount'))
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                (0, _formatting.sciFormatted)(totalImpressions)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                (0, _formatting.sciFormatted)(totalReach)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'likeCount'))
              ),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                (0, _formatting.sciFormatted)(_lodash2.default.sumBy(ungroupedPosts, 'commentCount'))
              ),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null),
              _react2.default.createElement(_semanticUiReact.Table.Cell, null)
            )
          )
        )
      )
    )
  );
};

InstagramReport.propTypes = {
  data: _propTypes2.default.object.isRequired,
  sort: _propTypes2.default.string.isRequired,
  groupBy: _propTypes2.default.string.isRequired,
  onSortChanged: _propTypes2.default.func.isRequired,
  onGroupByChanged: _propTypes2.default.func.isRequired,
  withHeader: _propTypes2.default.bool.isRequired
};

InstagramReport.defaultProps = {
  withHeader: false
};

exports.default = InstagramReport;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/instagram-report/index.js
 ** module id = 2591
 ** module chunks = 0
 **/